export { default } from './DateTab'
export type { DateTabProps } from './DateTab'